/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-navigation/back': {
    width: 16,
    height: 16,
    viewBox: '0 0 98 98',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><rect pid="0" width="98" height="98" rx="3.02" _fill="#373a36"/><path pid="1" d="M48.62 73.47l24.74-23v-13L53.57 55.86V19h-9.9v36.86l-19.8-18.41v13z" _fill="#fff"/></g></g>'
  }
})
